import { render, staticRenderFns } from "./EditForumHeader.vue?vue&type=template&id=2650f7be&"
import script from "./EditForumHeader.vue?vue&type=script&lang=js&"
export * from "./EditForumHeader.vue?vue&type=script&lang=js&"
import style0 from "./EditForumHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports